
export const getPDF =  (config,input, data) => {
    return new Promise((resolve,reject) => {
        const myHeaders = new Headers();
        const myFormData = new FormData();
        myFormData.append("config", JSON.stringify(config));
        myFormData.append("input",JSON.stringify(input));
        myFormData.append("data",JSON.stringify(data));
    
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body:myFormData,
          redirect: 'follow'
        };
    
        fetch(`https://api-geomec.solucioneskmp.com/Formatos/Pdf`, requestOptions)
          .then(response => response.json())
          .then(result => resolve(result))
          .catch(error => reject( error));
    })}